import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import V2App from './v2/V2App';

export default function App() {
  return (
    <Router>
      <V2App />
    </Router>
  );
}
